import api from 'api';

export const INGREDIENT_ASYNC_ACTION_START = 'INGREDIENT_ASYNC_ACTION_START';
export const INGREDIENT_ASYNC_ACTION_ERROR = 'INGREDIENT_ASYNC_ACTION_ERROR';
export const INGREDIENT_ASYNC_UPDATE_ACTION_SUCCESS = 'INGREDIENT_ASYNC_UPDATE_ACTION_SUCCESS';
export const INGREDIENT_ASYNC_ARCHIVE_ACTION_SUCCESS = 'INGREDIENT_ASYNC_ARCHIVE_ACTION_SUCCESS';
export const INGREDIENT_UPDATE_ACTION_SUCCESS = 'INGREDIENT_UPDATE_ACTION_SUCCESS';
export const INGREDIENT_RESET_STATE = 'INGREDIENT_RESET_STATE';
export const PRODUCT_CARD_ASYNC_UPDATE_ACTION_SUCCESS = 'PRODUCT_CARD_ASYNC_UPDATE_ACTION_SUCCESS';

function ingredientAsyncActionStart() {
  return {
    type: INGREDIENT_ASYNC_ACTION_START,
  };
}

function ingredientAsyncActionError(error) {
  return {
    type: INGREDIENT_ASYNC_ACTION_ERROR,
    error,
  };
}

function ingredientAsyncUpdateSuccess(data) {
  return {
    type: INGREDIENT_ASYNC_UPDATE_ACTION_SUCCESS,
    data,
  };
}

function ingredientAsyncArchiveSuccess() {
  return {
    type: INGREDIENT_ASYNC_ARCHIVE_ACTION_SUCCESS,
  };
}

export function updateIngredient(data) {
  return {
    type: INGREDIENT_UPDATE_ACTION_SUCCESS,
    data,
  };
}

export function ingredientResetState() {
  return {
    type: INGREDIENT_RESET_STATE,
  };
}

export function productCardAsyncUpdateSuccess(data) {
  return {
    type: PRODUCT_CARD_ASYNC_UPDATE_ACTION_SUCCESS,
    data,
  };
}

export function getIngredientAsync(id, brandId) {
  return (dispatch, getState) => {
    dispatch(ingredientAsyncActionStart());
    return api.request(`ingredient/?id=${ id }&brandId=${ brandId }`, 'get')
    .then((data) => {
      dispatch(ingredientAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(ingredientAsyncActionError('Unable to get ingredient'));
      throw (err);
    });
  };
}

export function createIngredientAsync(ingredient) {
  return (dispatch, getState) => {
    dispatch(ingredientAsyncActionStart());
    return api.request('ingredient', 'post', ingredient)
    .then((data) => {
      dispatch(ingredientAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(ingredientAsyncActionError('Unable to create ingredient'));
      throw (err);
    });
  };
}

export function updateIngredientAsync(ingredient, isCustIngredientRollUp = false) {
  return (dispatch) => {
    dispatch(ingredientAsyncActionStart());
    return api.request(`ingredient?isCustIngredientRollUp=${ isCustIngredientRollUp }`, 'put', ingredient)
    .then((data) => {
      dispatch(ingredientAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(ingredientAsyncActionError('Unable to update ingredient'));
      throw (err);
    });
  };
}

export function updateRecipeIngredient(ingredient) {
  return (dispatch, getState) => {
    
    return api.request('recipeIngredient', 'put', ingredient)
    .then((data) => {
      return data;
    })
    .catch((err) => {
      dispatch(ingredientAsyncActionError('Unable to update recipe ingredient'));
      throw (err);
    });
  };
}

export function archiveIngredientAsync(id, brandId, recipeId, isUserIngredient) {
  return (dispatch, getState) => {
    dispatch(ingredientAsyncActionStart());
    return api.request(`ingredient/archive?id=${ id }&brandId=${ brandId }&recipeId=${ recipeId }&isUserIngredient=${isUserIngredient}`, 'post')
    .then((data) => {
      dispatch(ingredientAsyncArchiveSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(ingredientAsyncActionError('Unable to archive ingredient'));
      throw (err);
    });
  };
}

export function getProductCardAsync(ingredient, brandId, supc) {
  return (dispatch, getState) => {
    dispatch(ingredientAsyncActionStart());
    return api.request(`brand/productInfo/?brandId=${brandId}&supc=${supc}`, 'get')
    .then((data) => {
      if (data) {
        const updateProductYieldData = ingredient.setIn(['yield'], data.yield);
        const updateNoOfEachesData = updateProductYieldData.setIn(['noOfEaches'], data.noOfEaches);
        const updateCustomUomIdData = updateNoOfEachesData.setIn(['customUomId'], data.customUomId);
        const updateCustomUomData = updateCustomUomIdData.setIn(['customUom'], data.customUom);
        dispatch(productCardAsyncUpdateSuccess(updateCustomUomData));
        return updateCustomUomData;
      }
      dispatch(updateIngredient(ingredient)); // brand_productinfo is not available
      return ingredient;
    })
    .catch((err) => {
      dispatch(ingredientAsyncActionError('Unable to get product card'));
      throw (err);
    });
  };
}

export function updateProductCardAsync(productCard) {
  return (dispatch, getState) => {
    dispatch(ingredientAsyncActionStart());
    return api.request(`brand/productInfo/`, 'put', productCard)
    .then((data) => {
      let currentIngredient = getState().editableTable.get('editableItem');
      if (currentIngredient) {
        currentIngredient = currentIngredient.setIn(['yield'], productCard.yield);
        currentIngredient = currentIngredient.setIn(['noOfEaches'], productCard.noOfEaches);
        currentIngredient = currentIngredient.setIn(['customUomId'], productCard.customUomId);
        dispatch(productCardAsyncUpdateSuccess(currentIngredient));
      }
      return currentIngredient;
    })
    .catch((err) => {
      dispatch(ingredientAsyncActionError('Unable to update product card'));
      throw (err);
    });
  };
}

export function createProductCardAsync(productCard) {
  return (dispatch, getState) => {
    dispatch(ingredientAsyncActionStart());
    return api.request(`brand/productInfo/`, 'post', productCard)
    .then((data) => {
      let currentIngredient = getState().editableTable.get('editableItem');
      if (currentIngredient) {
        currentIngredient = currentIngredient.setIn(['yield'], productCard.yield);
        currentIngredient = currentIngredient.setIn(['noOfEaches'], productCard.noOfEaches);
        dispatch(productCardAsyncUpdateSuccess(currentIngredient));
      }
      return currentIngredient;
    })
    .catch((err) => {
      dispatch(ingredientAsyncActionError('Unable to create product card'));
      throw (err);
    });
  };
}

export function createSearchIngredientAsync(ingredient) {
  return (dispatch, getState) => {
    dispatch(ingredientAsyncActionStart());
    return api.request('ingredient/additional', 'post', ingredient)
    .then((data) => {
      dispatch(ingredientAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(ingredientAsyncActionError('Unable to create ingredient'));
      throw (err);
    });
  };
}
